import { ClickAway } from '@components/core-ui/ClickAway';
import ReactDOM from 'react-dom';
import { TProps } from './types/TProps';

const popoverPanelClassName =
  'h-max w-max max-w-[calc(100vw-2rem)] max-h-[80dvh] overflow-auto border border-[var(--color-border)] bg-[var(--color-surface)] text-[var(--color-text)] shadow-[0_12px_24px_var(--color-shadow)]';

const popoverPositionDefaultClassName = 'absolute left-0 top-full z-[10000] mt-2';

const popoverPositionCustomClassName = 'absolute z-[10000]';

export const Popover = ({
  children,
  onClose,
  open,
  anchorEl,
  panelClassName = '',
  panelStyle,
  className = '',
}: TProps) => {
  const hasCustomPosition = Boolean(panelClassName.trim() || panelStyle);
  const positionClassName = hasCustomPosition ? popoverPositionCustomClassName : popoverPositionDefaultClassName;

  return open && anchorEl
    ? ReactDOM.createPortal(
        <ClickAway className={className} ignoreElement={anchorEl} onClickAway={onClose}>
          <div
            className={[positionClassName, popoverPanelClassName, panelClassName].filter(Boolean).join(' ')}
            style={panelStyle}
          >
            {children}
          </div>
        </ClickAway>,
        anchorEl,
      )
    : null;
};
